import { shortUrlEndpointIds } from 'root/src/server/modules/shortUrl/shortUrl.fixture';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const deleteShortUrlEndpoint = {
    [shortUrlEndpointIds.DELETE_SHORT_URL]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payload: {
            type: 'object',
            properties: {
                alias: {
                    type: 'string',
                },
            },
            required: ['alias'],
        },
    },
};
